import type { MessageCatalog } from './types';

/** Uzbek UI in Cyrillic script — generated from uz.ts via scripts/generate-uzc-catalog.mjs */
const uzc: MessageCatalog = {
  nav: {
    home: 'FalaRus',
    games: 'Ўйинлар',
    partner: 'Суҳбат',
    teachers: 'Ўқитувчилар',
    stats: 'Статистика',
    profile: 'Профил',
  },
  common: {
    user: 'Фойдаланувчи',
    save: 'Сақлаш',
    cancel: 'Бекор',
    back: 'Орқага',
    loading: 'Юкланмоқда...',
    loadError: 'Юклашда хато',
    retry: 'Қайтадан уриниш',
    today: 'Бугун',
    close: 'Ёпиш',
    copy: 'Нусхалаш',
    copied: 'Нусхаланди',
    share: 'Улашиш',
    saving: 'Сақланмоқда...',
    finish: 'Якунлаш',
    start: 'Бошлаш',
    send: 'Юбориш',
    unknown: 'Номаълум',
    pageNotFound: 'Саҳифа топилмади.',
    noData: 'Маълумот ёқ.',
  },
  language: {
    selectTitle: 'Тилни танланг',
    selectSubtitle: 'Интерфейс тилини танланг',
  },
  install: {
    cardTitle: 'Иловани бош экранга чиқаринг',
    cardSubtitle: 'Браузерсиз, бир босишда очинг',
    action: 'Чиқариш',
    dismiss: 'Кейинроқ',
    profileRow: 'Бош экранга чиқариш',
    guideTitle: 'Бош экранга чиқариш',
    guideIosIntro: 'iPhone’да буни Safari орқали қўшасиз:',
    guideIosStep1: 'Пастдаги «Улашиш» тугмасини босинг (юқорига стрелкали квадрат).',
    guideIosStep2: 'Рўйхатни пастга суринг ва «Бош экранга қўшиш»ни танланг.',
    guideIosStep3: 'Ўнг юқоридаги «Қўшиш»ни босинг — илова бош экранда пайдо бўлади.',
    guideAndroidIntro: 'Браузер менюси орқали қўшасиз:',
    guideAndroidStep1: 'Ўнг юқоридаги менюни (⋮) босинг.',
    guideAndroidStep2: '«Иловани ўрнатиш» ёки «Бош экранга қўшиш»ни танланг.',
    guideAndroidStep3: 'Тасдиқланг — илова бош экранда пайдо бўлади.',
    guideDesktopIntro: 'Компьютерда манзил қаторидан ўрнатасиз:',
    guideDesktopStep1: 'Манзил қаторининг ўнг чеккасидаги ўрнатиш белгисини босинг.',
    guideDesktopStep2: '«Ўрнатиш»ни тасдиқланг.',
    installed: 'Илова ўрнатилди!',
    dismissedHint: 'Бекор қилдингиз. Хоҳлаган вақтда қайта уриниб кўришингиз мумкин.',
    close: 'Ёпиш',
  },
  home: {
    premium: 'Премиум',
    patentTitle: 'Патент',
    patentSubtitle: 'Патентга тайёргарлик',
    vnzhTitle: 'ВНЖ',
    vnzhSubtitle: 'ВНЖга тайёргарлик',
    questGrammar: 'Грамматика',
    questGrammarSub: 'Қоидаларни ўрганиш',
    questVocab: 'Луғат',
    questVocabSub: 'Янги сўзлар',
    questReading: 'Ўқиш',
    questReadingSub: 'Матнни тушуниш',
    questSpeaking: 'Гапириш',
    questSpeakingSub: 'Суҳбат машқи',
    questSuhbat: 'Савол-жавоб',
    questSuhbatSub: 'Устоз билан суҳбат',
    questStart: 'Бошлаш',
    questRepeat: 'Такрорлаш',
    dayLabel: 'Кун {{day}}',
    stepLabel: 'Қадам {{current}} / {{total}}',
    minutesLabel: '~{{minutes}} дақиқа',
    prevDay: 'Олдинги кун',
    nextDay: 'Кейинги кун',
  },
  stats: {
    title: 'Статистика',
    calendarTitle: 'Фаоллик тақвими',
    calendarPrevMonth: 'Олдинги ой',
    calendarNextMonth: 'Кейинги ой',
    kunlikGrammar: 'Грамматика (ПЗЗ)',
    kunlikVocab: 'Луғат',
    kunlikReading: 'Ўқиш',
    kunlikSpeaking: 'Гапириш',
    kunlikSuhbat: 'Савол-жавоб',
    kunlikNone: 'Ҳали бошланмаган',
    kunlikContinue: 'Давом етиш',
    kunlikStart: 'Бошлаш',
    kunlikPrevDaysSingle: '{{day}}-кун якунланди',
    kunlikPrevDaysRange: '{{from}}–{{to}}-кунлар якунланди',
    kunlikGrammarFmt: '{{done}}/{{total}} машқ',
    kunlikVocabFmt: '{{done}}/{{total}} босқич',
    kunlikReadingDone: 'Бажарилди',
    kunlikReadingTodo: 'Қилинмаган',
    kunlikSpeakingFmt: '{{done}}/{{total}} топшириқ',
    kunlikSpeakingNoTasks: 'Бу кун учун топшириқ ё‘қ',
    kunlikReadingNoContent: 'Бу кун учун о‘қиш материаллари ё‘қ',
    kunlikOpenPlan: 'Кунлик режага о‘тиш',
  },
  partner: {
    title: 'Суҳбат',
    guestTitle: 'Суҳбат ва шериклар',
    guestSubtitle: 'Чатлар, гуруҳ ва шерик топиш учун киринг',
    guestLogin: 'Кириш',
    profiles: 'Анкеталар',
    profilesSub: 'Шерик танланг',
    incoming: 'Кирувчи сўровлар',
    outgoing: 'Чиқувчи сўровлар',
    adminChat: 'Support',
    groupChat: 'Савол-жавоб гуруҳи',
    partnerChat: 'Шерик билан ёзишма',
    noRequests: 'Ҳозирча сўровлар ёқ',
    noProfiles: 'Ҳозирча анкеталар ёқ',
    sendRequest: 'Сўров юбориш',
    requestSent: 'Сўров юборилди',
    acceptRequest: 'Қабул қилиш',
    rejectRequest: 'Рад етиш',
    cancelRequest: 'Сўровни бекор қилиш',
    pending: 'Жавоб кутилмоқда',
    male: 'Еркак',
    female: 'Аёл',
    yearsOld: '{{age}} ёш',
    chatSoon: 'Чат тез орада қўшилади',
    firstMessage: 'Биринчи хабарни юборинг!',
    messagePlaceholder: 'Хабар ёзинг...',
    endPartnership: 'Суҳбатни тугатиш',
    support: 'Қўллаб-қувватлаш',
    adminMessagePlaceholder: 'Хабар ёзинг...',
    adminPrompt: 'Support билан ёзишмалар',
    cancelingRequest: 'Бекор қилинмоқда...',
    endConfirmBody: 'Шериклик тугатилса, чат ёпилади ва қайта уланиш учун янги со‘ров керак бо‘лади.',
    endConfirmTitle: 'Суҳбатни тугатишни тасдиқланг',
    ending: 'Тугатилмоқда...',
    formAbout: 'О‘зингиз ҳақингизда',
    formAboutPlaceholder: 'Қисқача ёзинг...',
    formAge: 'Ёш',
    formAgePlaceholder: 'Масалан: 25',
    formCreateTitle: 'Анкета яратиш',
    formEditTitle: 'Анкетани таҳрирлаш',
    formGender: 'Жинс',
    formGoal: 'Мақсад',
    formLanguageLevel: 'Рус тили даражаси',
    formName: 'Исм',
    formNamePlaceholder: 'Исмингиз',
    formSelect: 'Танланг',
    formSubtitle: 'Шерик топиш учун маълумотларингизни киритинг',
    goalConversation: 'Суҳбат',
    goalWork: 'Иш',
    groupFallback: 'Савол-жавоб гуруҳи',
    groupFirstQuestion: 'Биринчи саволингизни ёзинг',
    groupQuestionPlaceholder: 'Савол ёзинг...',
    incomingSub: 'Сизга келган со‘ровлар',
    later: 'Кейинроқ',
    levelAdvanced: 'Илг‘ор',
    levelBeginner: 'Бошланг‘ич',
    levelElementary: 'Елементар',
    levelIntermediate: 'О‘рта',
    levelUpper: 'Юқори-о‘рта',
    membersOnline: '{{members}} аъзо · {{online}} онлайн',
    mentionAlert: 'Сизни белгилашди',
    mentionEmpty: 'Ҳеч ким топилмади',
    mentionTitle: 'Кимни белгилайсиз?',
    noProfilesSub: 'Бошқа фойдаланувчилар анкетасини яратганда улар шу ерда ко‘ринади',
    outgoingSub: 'Сиз юборган со‘ровлар',
    partnerLabel: 'Шерик',
    typingMany: '{{first}}, {{second}} ва бошқалар ёзмоқда...',
    typingOne: '{{name}} ёзмоқда...',
    typingTwo: '{{first}} ва {{second}} ёзмоқда...',
  },
  teachers: {
    videoTitle: 'Видео-тақдимот',
    title: 'Ўқитувчилар',
    subtitle: 'Тажрибали ўқитувчилардан дарс олинг',
    details: 'Батафсил',
    emptyTitle: 'Ҳозирча ўқитувчилар ёқ',
    emptyDesc: 'Фаол ўқитувчилар рўйхатга қўшилганда улар шу ерда кўринади.',
    notFound: 'Ўқитувчи топилмади',
    about: 'Мен ҳақимда',
    reviews: 'Ўқувчилар фикри',
    experience: 'Тажриба:',
    price: 'Ойлик курс:',
    formatOnline: 'Онлайн',
    formatOffline: 'Офлайн',
    priceNegotiable: 'Нарх келишилади',
    notSpecified: 'Кўрсатилмаган',
    student: 'Ўқувчи',
    trialBook: 'Синов дарсини банд қилиш',
    trialPending: 'Тўлов текширилмоқда',
    age: 'Ёш',
    lessonFormat: 'Дарс формати',
    region: 'Ҳудуд',
    reviewPlaceholder: 'Шарҳ',
    trialMessageHint: 'О‘қитувчига хабар қолдиринг (ихтиёрий)',
    trialMessagePlaceholder: 'Салом! Синов дарсини банд қилмоқчиман...',
    trialPayRub: 'Рубл билан то‘лаш',
    trialPayUzs: 'Сўм билан тўлаш',
    trialPaymentNavError: 'То‘лов саҳифасига о‘тиб бо‘лмади',
    trialPaymentPending: 'Синов дарси учун то‘лов аллақачон текширилмоқда',
    trialPendingBody: 'Админ тасдиқлагач сиз билан чат очилади ва дарс вақти келишилади.',
    trialRahmatStartError: 'Rahmat то‘лови бошланмади',
    trialRubHint: 'Россия картаси орқали то‘лов',
    loginTitle: 'Ўқитувчи кириши',
    cabinetLogin: 'Кабинетга кириш',
    loggingIn: 'Кирилмоқда...',
    identifierLabel: 'Емаил ёки телефон',
    loginError: 'Киришда хатолик юз берди',
  },
  courses: {
    title: 'Курслар',
    patentTitle: 'Патент имтиҳони',
    patentSubtitle: 'Патент имтиҳонига тайёрлов курси',
    vnzhTitle: 'ВНЖ имтиҳони',
    vnzhSubtitle: 'ВНЖ имтиҳонига тайёрлов курси',
  },
  games: {
    title: 'Ўйинлар',
    howToPlay: 'Қандай ўйналади',
    howToPlayText: 'Қўшни ҳарфлар бўйлаб бармоқ ёки сичқонча билан чизинг. Тўғри русча сўз топилса, пастдаги жавоб тўлдирилади. Ҳар бир катакдан бир марта фойдаланиш мумкин.',
    reset: 'Қайта бошлаш',
    hint: 'Маслаҳат',
    stageProgress: 'Босқич {{stage}} / {{total}}',
    levelLabel: '{{level}}-даража',
    nextStage: 'Кейинги босқич',
    availableStagesEnded: 'Ҳозирча очиқ босқичлар тугади',
    stageLocked: 'Бу босқич ҳали очилмаган',
    stageEmpty: 'Бу босқичда ҳозирча сўзлар ёқ',
    gridGenerationFailed: 'Жадвални яратиб бўлмади',
    loginRequired: 'Ўйнаш учун тизимга киринг',
    loginToPlay: 'Ўйнаш учун киринг',
    saveProgressFailed: 'Прогрессни сақлаб бўлмади',
  },
  invite: {
    title: 'Дўстларни таклиф қилиш',
    subtitle: 'Дўстларингизни таклиф қилинг ва бонус олинг',
    statInvites: 'Таклифлар',
    statRegistered: 'Рўйхатдан ўтган',
    statPaid: 'Тўлов қилган',
    statBalance: 'Бонус баланс',
    linkMissing: 'Ҳавола мавжуд емас',
    listTitle: 'Таклифлар роʻйхати',
    listEmpty: 'Ҳозирча таклифлар ёқ',
    statusPaid: 'Тўлов қилди',
    statusRegistered: 'Рўйхатдан ўтди',
    statusInvited: 'Таклиф юборилди',
    bonusNote: 'Бонус баланс автоматик янгиланади',
    shareText: 'FalaRus курсига қўшилинг',
  },
  help: {
    title: 'Ёрдам',
    admin: 'Админ',
    online: 'Онлайн',
    offline: 'Ёпиқ',
    noChats: 'Ҳозирча ёзишмалар ёқ',
    noMessages: 'Ҳозирча хабарлар ёқ',
    placeholder: 'Муаммо ёки саволингизни ёзинг...',
    image: 'Расм',
    uploadError: 'Расм юкланмади',
    messagesLoading: 'Хабарлар юкланмоқда...',
  },
  notFound: {
    title: 'Саҳифа топилмади',
    body: 'Манзил нотўғри ёки саҳифа кўчирилган бўлиши мумкин.',
    home: 'Бош саҳифа',
    login: 'Кириш',
    footerPatent: 'Патент курси',
    footerVnzh: 'ВНЖ курси',
    footerPricing: 'Тарифлар',
    footerPrefix: 'Рус тили патент учун ва ВНЖ бо‘лимлари:',
  },
  payment: {
    historyTitle: 'Тўловлар тарихи',
    statusPending: 'Текширилмоқда',
    statusApproved: 'Тасдиқланди',
    statusRejected: 'Рад етилди',
    empty: 'Ҳозирча тўловлар ёқ',
    popular: 'Енг машҳур',
    buyThreeMonth: '3 ОЙ',
    buyYear: '1 ЙИЛ',
    currency: 'сўм',
    acceptedBody: 'То‘ловингиз қабул қилинди.',
    acceptedDefault: 'Тасдиқлангандан со‘нг барча дарслар очилади.',
    acceptedTeacherTrial: 'Синов дарси учун админ тасдиқлашини кутинг.',
    acceptedTitle: 'То‘лов қабул қилинди',
    back: 'Орқага',
    backCabinet: 'Кабинетга қайтиш',
    backProfile: 'Профилга қайтиш',
    backTeacher: 'О‘қитувчиларга қайтиш',
    buyThreeMonthAction: '3 ойни сотиб олиш',
    buyYearAction: '1 йилни сотиб олиш',
    cardCopy: 'Карта рақамини нусхалаш',
    cardHolder: 'Карта егаси',
    cardNumber: 'Карта рақами',
    chooseAnotherFile: 'Бошқа файл танлаш',
    contactAdmin: 'Админ билан бог‘ланиш',
    course: 'Курс',
    fileSizeMax: 'Файл ҳажми 10 МБ дан ошмаслиги керак',
    fileTypes: 'Фақат JPG, PNG, WEBP ёки PDF',
    nameCopy: 'Исмни нусхалаш',
    needLogin: 'То‘лов учун аввал тизимга киринг',
    payExact: 'Аниқ шу суммани о‘тказинг',
    pendingDefault: 'То‘ловингиз администратор томонидан текширилмоқда. Тасдиқлангач кириш очилади.',
    pendingTeacherListing: 'Ро‘йхат то‘лови текширилмоқда. Тасдиқлангач профил фаоллашади.',
    pendingTeacherTrial: 'Синов дарси то‘лови текширилмоқда.',
    pendingTitle: 'Тўлов текширилмоқда',
    phoneCopy: 'Телефон рақамини нусхалаш',
    phoneNumber: 'Телефон рақами',
    rahmatStartError: 'Rahmat то‘ловини бошлашда хато',
    selectOrDrop: 'Файлни танланг ёки бу ерга ташланг',
    service: 'Хизмат',
    submit: 'Тўловни юбориш',
    submitting: 'Юборилмоқда...',
    tariff: 'Тариф',
    teacherTrialRubHint: 'Синов дарси нархи рублда ко‘рсатилган',
    teacherTrialUzsHint: 'Синов дарси: {{amount}} со‘м (Rahmat)',
    uploadFormats: 'JPG, PNG, WEBP ёки PDF, макс. 10 МБ',
    uploadReceipt: 'Чек ёки скриншот юкланг',
    uploaded: 'юкланди',
    amountTitle: 'Тўлов суммаси',
    currencyTitle: 'Тўлов валютасини танланг',
    currencySubtitle: 'Қайси валютада тўламоқчисиз?',
  },
  pricing: {
    pendingNotice: 'То‘ловингиз текширилмоқда. Тасдиқлангач Премиум фаоллашади.',
    alreadyActive: 'Премиум аллақачон фаол',
    loadError: 'Тарифлар юкланмади',
    whyTitle: 'Нега айнан бу курс?',
    ctaEnroll: 'Курсга ёзилиш',
    vocabTitle: 'Луғат — 3 босқичда',
    benefitGrammar: '182 кунлик грамматика режаси',
    benefitVocab: 'Ҳар куни янги сўзлар ва машқлар',
    benefitInteractive: 'Интерактив топшириқлар',
    benefitGames: 'О‘йинлар орқали о‘рганиш',
    benefitStats: 'Статистика ва кетма-кет кунлар',
    benefitLeaderboard: 'Рейтинг ва мотиватсия',
    whySmartTitle: 'Ақлли режа',
    whySmartDesc: 'Ҳар кун аниқ вазифалар — чалкашликсиз о‘рганасиз',
    whyGameTitle: 'О‘йин формати',
    whyGameDesc: 'Қизиқарли машқлар мотиватсияни сақлайди',
    whyStatsTitle: 'Прогресс кузатуви',
    whyStatsDesc: 'Натижаларингизни ко‘ринг ва ривожланинг',
    whyLeaderboardTitle: 'Рейтинг',
    whyLeaderboardDesc: 'Бошқалар билан рақобатлашинг ва г‘алаба қозонинг',
    vocabStepLearnDesc: 'Карточкалар орқали со‘зларни танишинг',
    vocabStepTestDesc: 'Тест орқали билимингизни текширинг',
    vocabStepPairsDesc: 'Рус ва о‘збек жуфтларини топинг',
  },
  rahmat: {
    title: 'То‘лов қабул қилинди',
    body: 'Агар кириш ҳали очилмаса, бир неча сониядан со‘нг профилни янгиланг. Rahmat то‘лови тасдиқлангач автоматик янгиланади.',
    goProfile: 'Профилга о‘тиш',
    goHome: 'Бош саҳифа',
  },
  kunlik: {
    noQuestions: 'Бу кун учун савол ёқ',
    selectAnswer: 'Тўғри жавобни танланг',
    arrangeSentence: 'Гапни тузинг',
    clear: 'Тозалаш',
    learnedWords: 'Ўрганилган сўзлар:',
    stepLearn: 'Танишиш',
    stepTest: 'Тест',
    stepPairs: 'Жуфтини топиш',
    completed: 'Тугаган',
    daySpeaking: 'Кун {{day}} · Гапириш',
    seqHint2: 'Аввал 1-вазифани тугатинг',
    seqHint3: 'Аввал 2-вазифани тугатинг',
    noVocabRows: 'Бу кун учун луғат бўш',
    knowDontKnow: 'Билади: {{known}} · Билмайди: {{unknown}}',
    goToLearn: 'Танишишга ўтиш',
    testLocked: 'Тест қулфланган',
    step2LockedHint: 'Аввал танишиш босқичини тугатинг',
    step3LockedHint: 'Тестдан камида 80% билан о‘тинг',
    allPairsFound: 'Барча жуфтлар топилди',
    ruUzPairs: 'Рус ва о‘збек жуфтлари',
    backToPlan: 'Кунлик режага қайтиш',
    noMatchPairs: 'Жуфтликлар топилмади',
    noReadingContent: 'Бу кун учун о‘қиш материаллари ё‘қ',
    noSpeakingTasks: 'Бу кун учун гапириш топшириқлари ё‘қ',
    noTasks: 'Бу кун учун топшириқлар ё‘қ',
    passed: 'О‘тди',
    readingDoneAlready: 'О‘қиш аллақачон бажарилган',
    readingFinishDelay: 'Якунлаш учун {{seconds}} сония о‘қинг',
    sentenceTestSoon: 'Гап тузиш тести тез орада ({{count}} савол)',
    speakingDoneAlready: 'Гапириш бо‘лими бажарилган',
    freeLimitTitle: 'Обуна керак',
    freeLimitBody:
      'Кунлик курс тўлиқ обуна билан очилади. Тўловдан кейин 182 куннинг ҳаммаси очиқ бўлади.',
    chooseTariff: 'Тарифни танлаш',
    continueCta: 'Давом етиш учун босинг',
    testHint: 'Камида 80% билан о‘тинг',
    vocabWords: 'Сўзлар',
    invalidDay: 'Кун рақами ното‘г‘ри',
    wordsShapeInvalid: 'Со‘злар шакли ното‘г‘ри',
    pairsLockedTitle: 'Жуфтликлар қулфланган',
    pairsLockedHint: 'Кейинги босқич очилиши учун камида 80% то‘г‘ри жавоб керак.',
    backToTest: 'Тестга қайтиш',
  },
  patent: {
    title: 'Патент имтиҳони',
    paywallTitle: 'Курс ёпиқ',
    paywallBuy: 'Сотиб олиш',
    resultsLoadError: 'Натижалар юкланмади',
    statusOpen: 'Очиқ',
    variantNotFound: 'Вариант топилмади',
    writeAnswerPlaceholder: 'Жавобни ёзинг',
  },
  vnzh: {
    rahmatStartError: 'Rahmat то‘лови бошланмади. Кейинроқ уриниб ко‘ринг.',
    backAria: 'Орқага',
    sectionNotFound: 'Бо‘лим топилмади',
  },
  profile: {
    tapPhoto: 'Расм учун босинг',
    premiumDaysLeft: 'Премиум · {{days}} кун қолди',
    groups: {
      personal: 'Шахсий',
      settings: 'Созламалар',
      help: 'Ёрдам',
    },
    rows: {
      profile: 'Профил',
      certificates: 'Сертификатлар',
      invite: 'Дўстларни таклиф қилиш',
      textSize: 'Матн ҳажми',
      notifications: 'Билдиришномалар',
      darkMode: 'Тунги режим',
      language: 'Тил',
      sound: 'Овоз ва тебраниш',
      help: 'Ёрдам',
      pricing: 'Тарифлар',
      paymentHistory: 'Тўловлар тарихи',
      logout: 'Чиқиш',
    },
    firstName: 'Исм',
    lastName: 'Фамилия',
    save: 'Сақлаш',
    cancel: 'Бекор',
    nameUpdated: 'Исм янгиланди',
    avatarUpdated: 'Профил расми янгиланди',
    avatarUploadFailed: 'Расм юкланмади',
    nameRequired: 'Исм ва фамилия тўлдирилиши керак',
    edit: 'Таҳрирлаш',
    gender: 'Жинс',
    genderMale: 'Еркак',
    genderFemale: 'Аёл',
    russianLevel: 'Рус тили даражаси',
    contactSecurity: 'Алоқа ва хавфсизлик',
    currentPassword: 'Жорий парол',
    newPassword: 'Янги парол',
    profileUpdated: 'Профил янгиланди',
    textSizeAria: 'Матн ҳажми',
  },
  auth: {
    benefits: {
    },
    register: 'Рўйхатдан ўтиш',
    logIn: 'Кириш',
    logInTitle: 'Кириш',
    createAccountTitle: 'Рўйхатдан ўтиш',
    phone: 'Телефон',
    email: 'Емаил',
    password: 'Парол',
    createPassword: 'Парол ўйлаб топинг',
    rewritePassword: 'Паролни қайта киритинг',
    name: 'Исм',
    surname: 'Фамилия',
    emailHint: 'усернаме@гмаил.cом',
    forgotPassword: 'Паролни унутдингизми?',
    or: 'ЙОКИ',
    continueWithGoogle: 'Google орқали давом етиш',
    noAccount: 'Ҳисобингиз ё‘қми? ',
    signUp: 'Рўйхатдан ўтиш',
    haveAccount: 'Ҳисобингиз борми? ',
    emailRequired: 'Емаил киритилиши шарт',
    emailInvalid: 'Емаил ното‘г‘ри',
    phoneInvalid: 'Телефон рақами ното‘г‘ри',
    passwordRequired: 'Парол киритилиши шарт',
    passwordMinLength: 'Парол камида 6 белгидан иборат бо‘лиши керак',
    passwordsMismatch: 'Пароллар мос келмайди',
    nameRequired: 'Исм киритилиши шарт',
    surnameRequired: 'Фамилия киритилиши шарт',
    termsPrefix: 'Ҳисоб очиш орқали мен ',
    termsOfUse: 'Фойдаланиш шартлари',
    termsAnd: ' ва ',
    privacyPolicy: 'Махфийлик сиёсати',
    termsSuffix: 'га розиман.',
    resetTitle: 'Паролни тиклаш',
    resetSubtitle: 'Емаил манзилингизга янги парол юборамиз',
    resetSendPassword: 'Янги парол юбориш',
    resetSuccessTitle: 'Емаил юборилди',
    resetSuccessSubtitle: 'Агар ҳисоб мавжуд бо‘лса, янги парол емаил манзилингизга юборилди',
    networkError: 'Интернет билан алоқа ё‘қ. Илтимос, қайта уриниб ко‘ринг.',
    genericError: 'Хатолик юз берди',
    loginRequired: 'Кириш керак',
  },
  liveStream: {
    badge: 'ЖОНЛИ',
    title: 'Жонли эфир',
    join: 'Эфирга кириш',
    watchingHint: 'Гапириш учун микрофон, кўриниш учун камера тугмасини босинг',
    callTitle: 'Жонли эфир бошланди',
    callJoin: 'Қўшилиш',
    callDecline: 'Кейинроқ',
    pushAllow: 'Рухсат',
    pushModalTitle: 'Эфир бошланганда қўнғироқ қиламиз',
    pushModalBody: 'Рухсат берсангиз, жонли эфир бошланган заҳоти телефонингизга хабар келади — илова ёпиқ бўлса ҳам.',
    pushLater: 'Кейинроқ',
    upcomingTitle: 'Яқинлашаётган эфирлар',
    noneTitle: 'Ҳозир жонли эфир йўқ',
    noneSubtitle: 'Эфир бошланганда бош саҳифада ва Суҳбат бўлимида хабар чиқади',
    back: 'Ортга',
    loadError: 'Эфир маълумоти юкланмади',
  },
};

export default uzc;
